import { render, staticRenderFns } from "./TabelaRegrasPagamento.vue?vue&type=template&id=c3926962&scoped=true&"
import script from "./TabelaRegrasPagamento.vue?vue&type=script&lang=js&"
export * from "./TabelaRegrasPagamento.vue?vue&type=script&lang=js&"
import style0 from "./TabelaRegrasPagamento.vue?vue&type=style&index=0&id=c3926962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3926962",
  null
  
)

export default component.exports